import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import Form from "react-bootstrap/Form";
// Custom components
import BarChart from "components/charts/BarChart";
import {
  barChartDataConsumption,
  barChartOptionsConsumption,
} from "variables/charts";
import { MdBarChart } from "react-icons/md";
import { getDifferenceFromPrevVal } from "jsFunctions/helperFunctions";
import { expenseOption,generateYearOptions  } from "./filterOption";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetOrganizationModuleType } from "redux/organizationModuleSlice";
const {yearOption,defaultSelected} = generateYearOptions();

export default function WeeklyRevenue(props) {
  const { ...rest } = props;
  const [option, setOption] = useState([]);
  const dispatch = useDispatch();
  const { currUser } = useSelector((state) => state?.auth);
  const auth = currUser?.auth || [];
  const role = ['Admin', 'Manager', 'Accountant'];

  const [value, setValue] = useState([]);
  const [valueDifference, setValueDifference] = useState(null);
  const [expOptions,setExpOptions] = useState([]);
  const iconColor = useColorModeValue("#22b378", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const moduleType = useSelector((state) => state.moduleType);

  useEffect(() => {
    setOption([]);
    setValueDifference(null);
    setOption(props.optionBarChart);
    setValue(props.valuesBarChart);
  }, [props.valuesBarChart, props.optionBarChart]);

  useEffect(() => {
    if (value.length > 0 && option.length > 0) {
      const diff = getDifferenceFromPrevVal(value);
      let getOption = barChartOptionsConsumption(option, diff);
      setValueDifference(getOption);
    }
  }, [value,option]);

  useEffect(()=>{
    dispatch(fetchAsyncGetOrganizationModuleType())
  },[])

  useEffect(()=>{
    if(moduleType && moduleType?.length > 0){

      const opt = moduleType.map((item)=>{
        return {
          label:item.name,
          value: item._id,
          module:item.name
        }
      })
      const allOpt = [...opt,...expenseOption];

      const filterOption = allOpt.filter(option => 
        auth.some(authItem => authItem.module === option.module && role.includes(authItem?.access))
      );
            setExpOptions(filterOption)
    }
    else{
      setExpOptions(expenseOption)
    }

  },[moduleType])
  return (
    <Card
      align="center"
      direction="column"
      w="110%"
      h="600px"
      p={0}
      // style={{ overflow: "scroll" }}
      {...rest}
      className="weekly-expense-graph"
    >
      <Flex className="weekly-graph-flex" align="center" w="100%" >
        <Text
          me="auto"

        >
          Expenses
        </Text>
        <Form.Select
          size="sm"
          className="dashboardSelect"
          onChange={(e) => props.changeYear(e.target.value)}
          value={props?.selectExpYear}
          defaultValue={defaultSelected}
        >
          <option>Select Financial Year</option>
          {yearOption.map((opt)=>{
            return <option value={opt.value}>{opt.label}</option>
          })}
          

        </Form.Select>
        <Form.Select
          size="sm"
          className="dashboardSelect"
          onChange={(e) => props.changeExpanse(e.target.value)}
          value={props?.selectExpType || expOptions[0]?.value}
          defaultValue="tds"
        >
          <option>Select expense</option>
          {expOptions.map((opt)=>{
            return <option value={opt.value}>{opt.label}</option>
          })}        
        </Form.Select>
        <Button
          align="center"
          justifyContent="center"
          bg={bgButton}
          _hover={bgHover}
          _focus={bgFocus}
          _active={bgFocus}
          w="37px"
          h="37px"
          lineHeight="100%"
          borderRadius="10px"
          {...rest}
        >
          <Icon as={MdBarChart} color={iconColor} w="24px" h="24px" />
        </Button>
      </Flex>

      <Box h="500px" mt="20px" 
      >
        {valueDifference !== null && option.length > 0 && (
          <BarChart
            chartData={barChartDataConsumption(value)}
            chartOptions={valueDifference}
            selectExpYear={props?.selectExpYear}
          />
        )}
      </Box>
    </Card>
  );
}
